<template>
<div>
  <div class="current-info">
      <h4>Tuần số: <span class="times">{{times}}</span></h4>
      <span class="info">Mã dự thưởng của bạn:</span>
      <div class="ticket-info">{{ticketid}}</div>
    </div>
  <div class="detailBox">
    <p>Cảm ơn quý khách đã tham gia chương trình khuyến mại Đọc tin hay, rinh quà liền tay của công ty TNHH Công Nghệ Mạng Thông Tin Việt Nam. Mọi thông tin về thể lệ chương trình quý khách hàng truy cập vào đường link: <a @click="jumpActive">https://vngaynay.vn/#/introduction.html</a> hoặc liên hệ đến đầu số 02836362900 để được hỗ trợ</p>
    <a @click="goHome"> >> Bỏ qua</a>
  </div>
  </div>
</template>
<script>
import * as cookies from "js-cookie";

export default {
  name: 'activedetail',
  data() {
    return {
      times:'',
      ticketid:'',
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    jumpActive() {
      this.$router.push({ path: "/introduction" });
    },
  },
  mounted () {
    this.times=cookies.get('cur_issue')||'xxxx';
    this.ticketid=cookies.get('cur_ticketid')||'xxxxxxx';
  },
}
</script>
<style scoped>
.current-info {
  display:block;
  position:relative;
  margin:4px 0;
  text-align:center;
}
.times{
  font-size:1.4em;
  color:red;
}
.ticket-info{
  display:block;
  width:300px;
  height:60px;
  line-height:60px;
  margin:0 auto;
  background-color:red;
  color:#fff;
  font-size:2em;
}
.info{
  display:inline-block;
  margin: 10px 0;
}
  .detailBox{
    position: relative;
    display: block;
    width: 60%;
    min-height: 400px;
    margin: 80px auto;
    text-align: center;
  }
  p{
    font-size: 20px;
    margin-bottom: 20px;
    text-align: left;
  }
  a{
    display: inline-block;
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// ActiveDetail.vue?16f808cd